import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PartnerReassignEditor from './editor';

@modal(
  {
    className: 'partner-reassign-editor-modal',
  },
  true,
)
class PartnerReassignEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, selectedPartners } = this.props;

    return (
      <div className="partner-reassign-editor">
        <div className="partner-reassign-editor__header">
          {t(`cms.referral.partner.reassign.editor.title`)}
          <CloseOutlined
            className="partner-reassign-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>
        <PartnerReassignEditor
          selectedPartners={selectedPartners}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PartnerReassignEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  selectedPartners: PropTypes.array.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PartnerReassignEditorContainer.defaultProps = {
  t: () => {},
  selectedPartners: [],
  handleCloseModal: () => {},
};

export default PartnerReassignEditorContainer;
